import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../app/providers/AuthProvider';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
import { Logo } from '../components/Logo';
import { COLORS } from '../../../core/constants/colors';

export const ForgotPasswordPage: React.FC = () => {
  const { forgotPassword } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await forgotPassword(email);
      setSuccess(true);
      setTimeout(() => {
        navigate(`/reset-password?email=${encodeURIComponent(email)}`);
      }, 2000);
    } catch (err: any) {
      setError(err.message || 'Failed to send reset code. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ backgroundColor: COLORS.extended.cultured }}
    >
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-10">
          <Logo />
          
          <div className="text-center mb-8">
            <h1
              className="text-3xl md:text-4xl font-bold mb-2"
              style={{ color: COLORS.primary.persianIndigo }}
            >
              Forgot Password?
            </h1>
            <p
              className="text-sm"
              style={{ color: COLORS.primary.persianIndigo, opacity: 0.7 }}
            >
              No worries, we'll send you reset instructions
            </p>
          </div>

          {success ? (
            <div
              className="p-4 rounded-lg text-center mb-6"
              style={{ backgroundColor: COLORS.primary.softLime + '40' }}
            >
              <p className="text-sm" style={{ color: COLORS.primary.persianIndigo }}>
                ✓ Reset code sent! Redirecting...
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <Input
                label="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your.email@example.com"
                required
              />

              {error && (
                <div
                  className="mb-4 p-3 rounded-lg"
                  style={{ backgroundColor: COLORS.extended.redSalsa + '20' }}
                >
                  <p className="text-sm" style={{ color: COLORS.extended.redSalsa }}>
                    {error}
                  </p>
                </div>
              )}

              <Button type="submit" disabled={loading}>
                {loading ? 'Sending...' : 'Send Reset Code'}
              </Button>
            </form>
          )}

          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/login')}
              className="text-sm font-semibold hover:underline"
              style={{ color: COLORS.user.queryButton }}
            >
              ← Back to login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};